import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

export enum StepperVariant {
  Default = 'default',
  EventHistory = 'eventHistory',
}

const stepperStyleParts = ['stepper', 'indicator', 'separator'] as const

const helpers = createMultiStyleConfigHelpers(stepperStyleParts)
export const StepperStyle = helpers.defineMultiStyleConfig({
  variants: {
    [StepperVariant.Default]: {},
    [StepperVariant.EventHistory]: {
      stepper: {
        gap: 0,
      },
      indicator: {
        '&[data-status=complete]': {
          borderWidth: '4px',
          borderColor: 'gray.700',
          backgroundColor: 'transparent',
        },
        boxSize: '1rem',
      },
      separator: {
        '&[data-orientation=vertical]': {
          width: '2px',
          position: 'absolute',
          height: '100%',
          maxHeight: `calc(100% - 1rem)`,
          top: `1rem`,
          insetStart: `calc(0.5rem - 1px)`,
        },
        '&[data-status=complete]': {
          bg: 'gray.500',
        },
      },
    },
  },
  defaultProps: {
    variant: StepperVariant.Default,
  },
})
